<template>
  <div class="wrapper-tax-purpose mx-auto">
    <h4 class="tax-purpose-title">Confirm or add more lot area to include adjacent lots.</h4>
    <h5 class="tax-purpose-hint">
      <!-- This may be an approximate value. -->
    </h5>

    <div class="tax-purpose-wrap" :key="update">
      <div class="tax-purpose-item">
        <div>
          <!-- <img src="../assets/img_vacancy.png" alt="" class="tax-purpose-image"> -->
          <p class="tax-purpose-text">Lot Area</p>
          <p v-if="area" class="tax-purpose-subtext">Total sf: {{ area.toLocaleString() }}</p>
        </div>
        <div class="tax-purpose-result">
          <p class="tax-purpose-percent">{{ `${area_custom_percent}%` }}</p>
          <p v-if="area_custom !== null" class="tax-purpose-sum">
            <span class="or-condition">or sf: </span>{{ `${area_custom.toLocaleString()}` }}
          </p>
        </div>
      </div>
      <CustomInputRange id="area" @slider_input="slider_input" :min_value="min_area" :max_value="max_area"
        :selected_value="area_custom">
      </CustomInputRange>
    </div>
    <div class="d-flex flex-column align-items-center manual-input">
      <p>
        or add area manually
      </p>
      <b-form-input id="area_custom" class="cust-input" :value="formatter(area_custom)" placeholder="Area" trim
        :formatter="formatter" @change="handleManualChange" :key="update"></b-form-input>
    </div>
    <!-- :formatter="formatter" -->
    <!-- lazy-formatter  -->
    <ButtonDefault @click="handleClickResult()" text="Next!" />
    <LowDensityModal></LowDensityModal>
    <NonResidentialDistrictModal></NonResidentialDistrictModal>
  </div>
</template>

<script>
import ButtonDefault from "@/components/ButtonDefault";
import CustomInputRange from "@/components/CustomInputRange";
import LowDensityModal from "@/components/LowDensityModal.vue";
import NonResidentialDistrictModal from "@/components/NonResidentialDistrictModal.vue";
import { mapGetters } from "vuex";
import { number } from "./../utils"

export default {
  name: "LotAreaConfirmation",
  components: {
    ButtonDefault,
    CustomInputRange,
    LowDensityModal,
    NonResidentialDistrictModal
  },
  computed: {
    ...mapGetters({
      bbl_data: 'get_BBLData',
      is_low_density: 'get_is_low_density',
      is_nonresidential_district: 'get_is_nonresidential_district',
      area_custom_store: 'get_area_custom',
      max_area: 'get_max_area'
    }),
    min_area() {
      // 20% less than the land area
      return Math.floor(this.bbl_data.landArea * 0.8)
    },
    area() {
      return this.bbl_data.landArea
    },
    area_custom_percent() {
      return Math.floor(this.area_custom * 100 / this.area)
    }
  },
  watch: {
    is_low_density: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.$nextTick(() => {
            this.$bvModal.show('low-density-modal')
          })
        }
      }
    },
    is_nonresidential_district: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.$nextTick(() => {
            this.$bvModal.show('non-residential-district-modal')
          })
        }
      }
    },
    area: {
      immediate: true,
      handler(newVal) {
        if (newVal && !this.area_custom) {
          this.area_custom = newVal;
        }
      }
    },
    // area_custom_store: {
    //   immediate: true,
    //   handler(newVal) {
    //     if (newVal) {
    //       this.handleManualChange(newVal)
    //     }
    //   }
    // }
  },
  data: () => ({
    area_custom: 0,
    update: 0
  }),
  created() {
    this.handleManualChange(this.area_custom_store)
  },
  methods: {
    formatter(value) {
      const nvalue = Number(String(value).replace(/,/g, ''))
      // console.log('formatter', value, number(nvalue))

      return number(nvalue)
    },
    handleManualChange(value) {
      if(!value) return
      const nvalue = Number(String(value).replace(/,/g, ''))
      const newvalue = nvalue > this.max_area ? this.max_area : nvalue < this.min_area ? this.area : nvalue

      // console.log('handleManualChange', this.area_custom, nvalue, newvalue)

      this.area_custom = newvalue;
      this.$store.commit('setAreaCustom', newvalue)
      this.update++
    },
    async handleClickResult() {
      this.$store.dispatch('sendInfo', { step: this.$route.meta.step })
      this.$router.push({ name: 'lot-type-selection' })
    },
    slider_input({ inputValue }) {
      // console.log('inputValue', inputValue)
      this.area_custom = Number(inputValue);
      this.$store.commit('setAreaCustom', this.area_custom)
      // this.update++
      // this.area_custom_percent = Math.floor(this.area_custom * 100 / this.area);
    },
  }
}
</script>

<style lang="scss" scoped>
@import "../scss/variables.scss";

.manual-input {
  margin-top: 20px;
}

.wrapper-input-range {
  margin-top: 5px;
}

.wrapper-tax-purpose {
  height: 422px;
  width: 100%;
  border-radius: 12px;
  background-color: #FFFFFF;
  box-shadow: 0 2px 8px 0 rgba(26, 41, 60, 0.1);
  padding: 24px;
}

.tax-purpose-title {
  height: 33px;
  color: $font-black;
  font-size: 20px;
  letter-spacing: 0;
  line-height: 33px;
  text-align: center;
  width: 100%;
  margin-bottom: 6px;
}

.tax-purpose-hint {
  height: 19px;
  width: 100%;
  color: $font-gray;
  font-family: "Open Sans";
  font-size: 14px;
  letter-spacing: 0;
  line-height: 19px;
  text-align: center;
  margin-bottom: 24px;
}

.btn-default {
  width: 264px;
  margin: 24px auto 0;
  display: block;
}

.tax-purpose-wrap {
  padding: 19px 20px;
  height: 120px;
  width: 824px;
  border-radius: 10px;
  background-color: $common-bg;
  margin-bottom: 8px;
  border: 1px solid $common-bg;
}

.tax-purpose-wrap:hover {
  border: 1px solid rgba(11, 40, 78, 0.2);
  border-radius: 10px;
  background-color: transparent;
}

.tax-purpose-wrap:hover .tax-purpose-sum {
  color: #082E60;
}

.tax-purpose-wrap:hover .tax-purpose-percent {
  color: #082E60;
}

.tax-purpose-item {
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-justify-content: flex-start;
  -ms-flex-pack: start;
  justify-content: flex-start;
  -webkit-align-content: stretch;
  -ms-flex-line-pack: stretch;
  align-content: stretch;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}

.tax-purpose-image,
.tax-purpose-text {
  -webkit-order: 0;
  -ms-flex-order: 0;
  order: 0;
  -webkit-flex: 0 1 auto;
  -ms-flex: 0 1 auto;
  flex: 0 1 auto;
  -webkit-align-self: auto;
  -ms-flex-item-align: auto;
  align-self: auto;
}

.tax-purpose-image {
  height: 40px;
  float: left;
  width: 35px;
}

.tax-purpose-text {
  color: $font-black;
  font-size: 20px;
  letter-spacing: 0;
  line-height: 27px;
  margin-bottom: 3px;
  // margin-left: 56px;
}

.tax-purpose-subtext {
  color: $font-gray;
  font-size: 14px;
  letter-spacing: 0;
  line-height: 19px;
  margin-bottom: 0;
  // margin-left: 58px;
}

.tax-purpose-percent {
  text-align: right;
  color: $font-blue;
  font-size: 20px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 19px;
  margin-bottom: 6px;
}

.tax-purpose-sum {
  text-align: right;
  color: $font-blue;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 19px;
  margin-bottom: 0;
}

.tax-purpose-sum .or-condition {
  color: $font-gray;
  font-weight: normal;
}

.tax-purpose-result {
  -webkit-order: 0;
  -ms-flex-order: 0;
  order: 0;
  -webkit-flex: 1 0 auto;
  -ms-flex: 1 0 auto;
  flex: 1 0 auto;
  -webkit-align-self: auto;
  -ms-flex-item-align: auto;
  align-self: auto;
  text-align: right;
}

.cust-input {
  height: 48px;
  width: 200px;
  border-radius: 6px;
  border-color: transparent;
  background-color: #F9FAFF;
  font-family: "Open Sans";
  font-size: 15px;
  letter-spacing: 0;
  line-height: 20px;
  color: #0A1250;
  text-align: center;

  &::placeholder {
    color: #7F83A7;
    font-family: "Open Sans";
    font-size: 15px;
    letter-spacing: 0;
    line-height: 20px;
  }

  &:active {
    box-sizing: border-box;
    height: 48px;
    border: 1px solid #4D59EB;
    border-radius: 6px;
  }

  &:focus {
    box-shadow: none;
    border: 1px solid #4D59EB;
  }
}

@media screen and (max-width: 768px) {
  .tax-purpose-title {
    height: 60px;
    line-height: 30px;
  }

  .wrapper-tax-purpose {
    height: 440px;
    width: 720px;
    padding: 20px;
  }

  .tax-purpose-hint {
    margin-bottom: 20px;
  }

  .btn-default {
    margin-top: 20px;
  }

  .tax-purpose-wrap {
    width: 680px;
    margin-bottom: 0;
  }
}

@media screen and (max-width: 420px) {
  .wrapper-tax-purpose {
    width: 390px;
    padding: 16px;
    border-radius: 0;
  }

  .tax-purpose-title {
    height: 56px;
    width: 358px;
    font-size: 19px;
    line-height: 28px;
    text-align: center;
  }

  .tax-purpose-hint {
    height: 17px;
    width: 196px;
    font-size: 12px;
    line-height: 17px;
    text-align: center;
    margin-right: auto;
    margin-left: auto;
  }

  .tax-purpose-wrap {
    width: 358px;
    margin-bottom: 0;
    padding: 16px 12px;
  }

  .btn-default {
    width: 358px;
    margin-bottom: 8px;
  }
}

@media screen and (max-width: 375px) {
  .wrapper-tax-purpose {
    // height: 320px;
    width: 375px;
  }

  .tax-purpose-title {
    height: 56px;
    width: 350px;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
  }

  .tax-purpose-wrap {
    width: 343px;
  }

  .btn-default {
    width: 343px;
    margin-bottom: 8px;
  }
}

@media screen and (max-width: 320px) {
  .wrapper-tax-purpose {
    width: 320px;
  }

  .tax-purpose-title {
    height: 70px;
    width: 298px;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
  }

  .tax-purpose-wrap {
    width: 288px;
  }

  .btn-default {
    width: 288px;
    margin-bottom: 8px;
  }

}
</style>